define('GuestOrderStatus.ConstantVars', [
    'SC.Configuration',
    'underscore'
], function GuestOrderStatusConfiguration(
    Configuration,
    _
) {
    'use strict';

    var isPickupInStoreEnabled = Configuration.get('siteSettings.isPickupInStoreEnabled');

    var guestOrderConfig = { isBOPISEnabled: isPickupInStoreEnabled };

    if (isPickupInStoreEnabled) {
        guestOrderConfig.secondField = [{
            id: 'email',
            name: 'Email Address',
            validation: {
                pattern: 'email'
            }
        }];
    } else {
        guestOrderConfig.secondField = [{
            id: 'shipzip',
            name: 'Shipping Address Zip Code'
        }, {
            id: 'email',
            name: 'Email Address',
            validation: {
                pattern: 'email'
            }
        }];
    }

    _.extend(guestOrderConfig, {
        get: function get() {
            return this;
        }
    });

    if (!Configuration.publish) {
        Configuration.publish = [];
    }

    Configuration.publish.push({
        key: 'GuestOrderStatus_DevConfig',
        model: 'GuestOrderStatus.Configuration',
        call: 'get'
    });

    return guestOrderConfig;
});
